const convertBigIntToHex = (str: string): string => {
    const dec = str.toString().split('')
    const sum = []
    while (dec.length) {
        const decToNumber = Number(dec.shift())
        let s = 1 * decToNumber
        for (let i = 0; s || i < sum.length; i++) {
            s += (sum[i] || 0) * 10
            sum[i] = s % 16
            s = (s - sum[i]) / 16
        }
    }

    const hex: string = sum
        .reverse()
        .map((item) => item.toString(16))
        .join('')

    return hex
}

export default convertBigIntToHex
